import { enumItems } from './enumItems';
import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { SelectField } from '../components/Table/fields/SelectField';
import { DateField } from '../components/Table/fields/DateField';
import { TimeField } from '../components/Table/fields/TimeField';
import { servicePrice } from './servicePrice';
import { statuses } from './statuses';
import { servicePackage } from './servicePackage';
import { SelectFieldWithoutAutocomplete } from '../components/Table/fields/SelectFieldWithoutAutocomplete';
import { ServiceReservationFinance } from '../components/LegalAndFinance/ServiceReservationFinance';
import { CommentWall } from '../components/Comment/CommentWall';
import { ServiceReservationLog } from '../components/Log/ServiceReservationLog';
export const serviceReservation: SchemaWithClient<any> = {
  name: 'Service Reservations',
  pluralName: 'Service Reservations',

  tabs: [
    {
      id: 1,
      label: 'General',
      name: 'general',
    },
    {
      id: 2,
      label: 'Finances',
      name: 'finances',
      type: 'custom',
      renderer: ServiceReservationFinance,
    },
    {
      id: 3,
      label: 'Comments',
      name: 'comments',
      type: 'custom',
      renderer: CommentWall,
      rendererType: 'service_reservations',
    },
    {
      id: 4,
      label: 'History',
      name: 'logs',
      type: 'custom',
      renderer: ServiceReservationLog,
    },
  ],

  columns: {
    name: {
      name: 'Name',
      fieldRenderer: TextField,
      fieldType: 'text',
      readOnly: true,
      hide: true,
    },

    activity_reservation: {
      name: 'Activity Reservation',
      fieldRenderer: SelectField.tableAdapter(enumItems.activityReservation),
      url: enumItems.activityReservation.client.getAllPath,
      tempSchema: enumItems.activityReservation,
      switchboard: true,
    },
    service: {
      name: 'Service',
      fieldRenderer: SelectField.tableAdapter(servicePackage()),
      url: servicePackage().client.getAllPath,
      tempSchema: servicePackage(),
      switchboard: true,
    },
    date: {
      name: 'Date',
      fieldRenderer: DateField,
      fieldType: 'date',
      width: 'medium',
    },
    time: {
      name: 'Time',
      fieldRenderer: TimeField,
      fieldType: 'time',
      width: 'medium',
    },
    size: {
      name: 'Size',
      fieldRenderer: NumberField,
      fieldType: 'number',
    },
    price: {
      name: 'Price',
      fieldRenderer: SelectField.tableAdapter(servicePrice),
      url: servicePrice.client.getAllPath,
      tempSchema: servicePrice,
      switchboard: true,
    },
    currency: {
      name: 'Currency',
      fieldRenderer: SelectField.tableAdapter(enumItems.currency),
      switchboard: true,
      url: enumItems.currency.client.getAllPath,
      tempSchema: enumItems.currency,
    },
    discounted_price: {
      name: 'Discounted Price',
      fieldRenderer: NumberField,
      fieldType: 'number',
    },
    discounted_currency: {
      name: 'Currency',
      fieldRenderer: SelectField.tableAdapter(enumItems.currency),
      switchboard: true,
      url: enumItems.currency.client.getAllPath,
      tempSchema: enumItems.currency,
    },
    service_se_status: {
      name: 'Service SE Status',
      fieldRenderer: SelectFieldWithoutAutocomplete.tableAdapter(
        statuses.serviceSeStatus
      ),
      switchboard: true,
      url: statuses.serviceSeStatus.client.getAllPath,
      tempSchema: statuses.serviceSeStatus,
    },
    service_sp_status: {
      name: 'Service SP Status',
      fieldRenderer: SelectFieldWithoutAutocomplete.tableAdapter(
        statuses.serviceSpStatus
      ),
      switchboard: true,
      url: statuses.serviceSpStatus.client.getAllPath,
      tempSchema: statuses.serviceSpStatus,
    },

    selected_staff: {
      name: 'Selected Staff',
      fieldRenderer: SelectField.tableAdapter(enumItems.user),
      switchboard: true,
      url: enumItems.user.client.getAllPath,
      tempSchema: enumItems.user,
    },

    selected_staff_role: {
      name: 'Selected Staff Role',
      fieldRenderer: SelectField.tableAdapter(enumItems.subRole),
      switchboard: true,
      url: enumItems.subRole.client.getAllPath,
      tempSchema: enumItems.subRole,
    },

    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  viewTable: 'service_reservations',
  client: new Client(`/service-reservations`),
};
